import PropTypes from 'prop-types';
import {
  LANGUAGES,
  CONTENT_MODULE_TYPES,
  PEOPLE_MODULE_PHOTO_STYLE,
  PEOPLE_MODULE_PHOTO_STYLES,
  PEOPLE_MODULE_DISPLAY,
  PEOPLE_MODULE_DISPLAYS,
  GALLERY_MODULE_DISPLAY,
  GALLERY_MODULE_DISPLAYS,
} from 'shared/constants';

// COMMON PROPS
export const commonOwnerPropTypes = {
  type: PropTypes.oneOf(CONTENT_MODULE_TYPES).isRequired,
  order: PropTypes.number.isRequired,
  content: PropTypes.object.isRequired
};

export const commonPublicPropTypes = {
  type: PropTypes.oneOf(CONTENT_MODULE_TYPES).isRequired,
  content: PropTypes.object.isRequired
};

export const commonFormPropTypes = {
  id: PropTypes.string,
  type: PropTypes.oneOf(CONTENT_MODULE_TYPES).isRequired,
  order: PropTypes.number,
  content: PropTypes.object,
};

// PROPS BY TYPE
export const textPublicPropTypes = {
  title: PropTypes.string,
  text: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
};

export const textOwnerPropTypes = {
  title: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }).isRequired,
  text: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }).isRequired,
  fullWidth: PropTypes.bool,
};

export const peoplePersonPublicPropTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  headline: PropTypes.string,
  description: PropTypes.string,
  contacts: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
  })),
  order: PropTypes.number.isRequired,
};

export const peoplePersonOwnerPropTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  headline: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }),
  description: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }),
  contacts: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
  })),
  order: PropTypes.number.isRequired,
};

export const peoplePersonFormPropTypes = {
  id: PropTypes.string,
  url: PropTypes.string,
  name: PropTypes.string,
  headline: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }),
  description: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }),
  contacts: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string,
  })),
};

export const peoplePublicPropTypes = {
  photoSize: PropTypes.number.isRequired,
  photoStyle: PropTypes.oneOf(PEOPLE_MODULE_PHOTO_STYLES).isRequired,
  display: PropTypes.oneOf(PEOPLE_MODULE_DISPLAYS).isRequired,
  cols: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  persons: PropTypes.arrayOf(PropTypes.shape(peoplePersonPublicPropTypes)).isRequired,
  fullWidth: PropTypes.bool,
};

export const peopleOwnerPropTypes = {
  photoSize: PropTypes.number.isRequired,
  photoStyle: PropTypes.oneOf(PEOPLE_MODULE_PHOTO_STYLES).isRequired,
  display: PropTypes.oneOf(PEOPLE_MODULE_DISPLAYS).isRequired,
  cols: PropTypes.number,
  title: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }),
  description: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }),
  persons: PropTypes.arrayOf(PropTypes.shape(peoplePersonOwnerPropTypes)).isRequired,
  fullWidth: PropTypes.bool,
};

export const galleryPhotoPublicPropTypes = {
  id: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  description: PropTypes.string,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  order: PropTypes.number.isRequired,
};

export const galleryPhotoOwnerPropTypes = {
  id: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  description: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }),
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  order: PropTypes.number.isRequired,
};

export const galleryPhotoFormPropTypes = {
  id: PropTypes.string,
  src: PropTypes.string,
  description: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }),
  width: PropTypes.number,
  height: PropTypes.number,
};

export const galleryPublicPropTypes = {
  display: PropTypes.oneOf(GALLERY_MODULE_DISPLAYS).isRequired,
  margin: PropTypes.number.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
  photos: PropTypes.arrayOf(PropTypes.shape(galleryPhotoPublicPropTypes)).isRequired,
  fullWidth: PropTypes.bool,
};

export const galleryOwnerPropTypes = {
  display: PropTypes.oneOf(GALLERY_MODULE_DISPLAYS).isRequired,
  margin: PropTypes.number.isRequired,
  title: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }),
  description: PropTypes.shape({
    [PropTypes.oneOf(LANGUAGES)]: PropTypes.string
  }),
  photos: PropTypes.arrayOf(PropTypes.shape(galleryPhotoOwnerPropTypes)).isRequired,
  fullWidth: PropTypes.bool,
};

// DEFAULTS BY TYPE
export const textOwnerDefaultProps = {
  title: {},
  text: {},
  fullWidth: false,
};

export const peopleOwnerDefaultProps = {
  photoSize: 150,
  photoStyle: PEOPLE_MODULE_PHOTO_STYLE.CIRCLE,
  display: PEOPLE_MODULE_DISPLAY.LIST,
  cols: 1,
  title: {},
  description: {},
  persons: [],
  fullWidth: false,
};

export const peoplePersonFormDefaultProps = {
  id: null,
  url: null,
  name: '',
  headline: {},
  description: {},
  contacts: []
};

export const galleryOwnerDefaultProps = {
  display: GALLERY_MODULE_DISPLAY.ROWS,
  margin: 8,
  title: {},
  description: {},
  photos: [],
  fullWidth: false,
};

export const galleryPhotoFormDefaultProps = {
  id: null,
  src: null,
  description: {},
};
